import * as coreEntities from 'core/store/index';
import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { applyAiMascotTheme, getAiMascotTheme } from './aiMascotTheme';

/**
 * Keeps the AI mascot theme on `<html>` in sync with the current tenant. Layout effect so the
 * attribute lands before the first paint of anything that shows the mascot.
 */
export function useAiMascotTheme(): void {
  const client = useSelector((state: unknown) => coreEntities.organization.selectors.getClient(state)) as string | null | undefined;

  useLayoutEffect(() => {
    applyAiMascotTheme(getAiMascotTheme(client));
  }, [client]);
}
